var alignment_rtlignore_default = {
  "alignLeft": "F7BsK",
  "textWrapNowrap": "ZfsLa",
  "alignRight": "rrvTi",
  "alignCenter": "NlcS2",
  "sizeFullWidth": "_-7Yua",
  "renderedInTable": "nZM5B",
  "sizeOriginal": "qyczu",
  "sizeContent": "ly7aR",
  "sizeSmall": "_5foPI",
  "sizeSmallCenter": "oOWr8",
  "flex": "GmZAU",
  "LEFT": "t1bD3",
  "CENTER": "S9qoV",
  "RIGHT": "Cizkc",
  "AUTO": "NFk-9",
  "JUSTIFY": "Ax6Q2"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
